export default __webpack_public_path__ + "static/media/Cross.7fdd6070.svg";